import PropTypes from "prop-types"
import { Person } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function MemberDatasetsHeader({ account, name }) {
  const memberName = name ? `Dataset Entitlements: ${name}` : "Dataset Entitlements"
  return <Header Icon={Person} title={memberName} account={account} />
}

MemberDatasetsHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.member.data.member.name") }), null)(MemberDatasetsHeader)
